var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: 12,
            "form-context": _vm.formContext,
            icon: "inticon-users",
            title: "Abweichender Reparaturbetrieb",
          },
          on: { save: _vm.saveDifferingRepairFirmFormData },
        },
        [
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Abweichender Reparaturbetrieb",
                  "options-loader": _vm.loadDifferingRepairFirmOptions,
                  property: "differingRepairFirm",
                  type: "autocomplete",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "display-value",
                      fn: function () {
                        return [
                          _c("p", [
                            _vm.firmData.name
                              ? _c("span", [
                                  _c("b", [_vm._v(_vm._s(_vm.firmData.name))]),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.firmData.street
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.firmData.street)),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.firmData.postalCode || _vm.firmData.city
                              ? _c("span", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.firmData.postalCode) +
                                      " " +
                                      _vm._s(_vm.firmData.city)
                                  ),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.firmData.countryName
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.firmData.countryName)),
                                  _c("br"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm.firmData.phone
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.firmData.phone)),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.firmData.email
                              ? _c("span", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "mailto:" + _vm.firmData.email,
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.firmData.email))]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2679382243
                ),
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  dependencies: ["differingRepairFirm"],
                  "form-context": _vm.formContext,
                  label: "Reparaturbetrieb-Sachbearbeiter",
                  "options-loader": _vm.loadDifferingRepairFirmUserOptions,
                  property: "differingRepairFirmUser",
                  type: "autocomplete",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "display-value",
                      fn: function () {
                        return [
                          _c("p", [
                            _vm.userData.name
                              ? _c("span", [
                                  _c("b", [_vm._v(_vm._s(_vm.userData.name))]),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userData.street
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.userData.street)),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userData.postalCode || _vm.userData.place
                              ? _c("span", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.userData.postalCode) +
                                      " " +
                                      _vm._s(_vm.userData.place)
                                  ),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userData.countryName
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.userData.countryName)),
                                  _c("br"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm.userData.phone
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.userData.phone)),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userData.email
                              ? _c("span", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "mailto:" + _vm.userData.email,
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.userData.email))]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4278266274
                ),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "clear-float" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }